import {useState, useEffect} from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import PromotionSwitcher from "./PromotionSwitcher";
import {PromotionInterface} from "../../../interfaces/news/PromotionInterface";
import {PromotionTabs} from "./Promotions";

export default function PromotionsList({
    promotions,
    tab,
    setTab,
}: {
    promotions: PromotionInterface[];
    tab: PromotionTabs;
    setTab: (tab: PromotionTabs) => void;
}) {
    const [showPromotion, setShowPromotion] = useState(false);
    const [currentPromotion, setCurrentPromotion] = useState<PromotionInterface | null>(null);

    const ShowPromotion = (promotion: PromotionInterface) => {
        setCurrentPromotion(promotion);
        setShowPromotion(true);
        
        const newUrl = `${window.location.origin}${window.location.pathname}?promotion=${promotion.id}`;
        window.history.pushState({ promotionId: promotion.id }, '', newUrl);
    };

    const closePromotion = () => {
        setShowPromotion(false);
        setCurrentPromotion(null);
        
        const originalUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.pushState({}, '', originalUrl);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const promotionId = urlParams.get('promotion');
        
        if (promotionId) {
            const promotion = promotions.find(p => p.id.toString() === promotionId);
            if (promotion) {
                ShowPromotion(promotion);
            }
        }
    }, [promotions]);

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            if (event.state?.promotionId) {
                const promotion = promotions.find(p => p.id.toString() === event.state.promotionId);
                if (promotion) {
                    setCurrentPromotion(promotion);
                    setShowPromotion(true);
                }
            } else {
                setShowPromotion(false);
                setCurrentPromotion(null);
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [promotions]);

    const getColumnClass = (index: number) => {
        const totalItems = promotions.length;
        const itemsInLastRow = totalItems % 3;
        const isLastRow = index >= totalItems - itemsInLastRow;
        
        if (isLastRow && itemsInLastRow !== 0 && itemsInLastRow < 3) {
            return "stocks__item--half";
        }
        return "col-lg-4";
    };

    return (
        <HelmetProvider>
            <Helmet>
                <title>{currentPromotion ? currentPromotion.title : 'Акции и промокоды'}</title>
            </Helmet>
            
            {showPromotion && (
                <>
                    {currentPromotion && (
                        <div className="modal fade modal-stocks modal-promotions show" style={{display: "block"}}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                        <button
                                                type="button"
                                                className="close"
                                                onClick={closePromotion}
                                            />
                                    <div className="modal-body">
                                        <div className="modal-stocks__head">
                                            <div className="modal-stocks__header-content">
                                                <h3 className="f-exp">{currentPromotion.title}</h3>
                                                <p >{currentPromotion.subtitle}</p>
                                            </div>
                                       
                                        </div>
                                        
                                        {/* 
                                        <button 
                                            className="btn btn-secondary modal-stocks__copy-btn" 
                                            onClick={() => {
                                                const url = `${window.location.origin}${window.location.pathname}?promotion=${currentPromotion?.id}`;
                                                navigator.clipboard.writeText(url).then(() => {
                                                    alert('URL акции скопирован в буфер обмена');
                                                });
                                            }}
                                        >
                                            <i className="ico ico-copy-white"></i>
                                        </button>
                                        */}

                                        <div
                                            className="modal-stocks__body "
                                            dangerouslySetInnerHTML={{__html: currentPromotion.body || ""}}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            <div className="row">
                <div className="col">
                    <h1 className="stocks__title f-exp">Акции и промокоды</h1>

                    <div className="stocks__tabs">
                        <PromotionSwitcher tab={tab} setTab={setTab} />
                    </div>
                    <div className="tab-content">
                        <div className={"tab-pane show active"}>
                            <div className="stocks__list row">
                                {promotions.map((promotion, index) => (
                                    <div className={getColumnClass(index)} key={promotion.id}>
                                        <div className="stocks__item">
                                            <div className="stocks__block">
                                                <picture>
                                                    <source srcSet={promotion.image} media="(max-width: 992px)" />
                                                    <img src={promotion.image} alt={promotion.image} />
                                                </picture>
                                                <h3 className="f-exp">{promotion.title}</h3> 
                                                <p>{promotion.subtitle}</p> 
                                            </div>

                                            <button
                                                className="btn btn-primary"
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    ShowPromotion(promotion);
                                                }}
                                            >
                                                {" "}
                                                Подробнее
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </HelmetProvider>
    );
}
